import { get } from "@ember/object"
import Route from "@ember/routing/route"
import { later } from "@ember/runloop"
import { inject as service } from "@ember/service"

export default class UserRoute extends Route {
  @service("ember-store")
  store

  @service
  session

  @service
  headData

  // This ensures beforeModel is run everytime the query param changes
  queryParams = {
    step: { refreshModel: true },
  }

  beforeModel(transition) {
    super.beforeModel(...arguments)
    this.headData.robots = "nofollow"
    if (get(this, "session.isAuthenticated") !== true && transition.targetName === "user.sign-up") {
      later(() => {
        this.transitionTo({ queryParams: { step: 1 } })
      }, 200)
      return
    }

    if (
      get(this, "session.isAuthenticated") === true &&
      (transition.targetName === "user.sign-in" || transition.targetName === "user.sign")
    ) {
      this.transitionTo("user.show", get(this, "session.userId"))
    }
  }
}
